"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSolutionOwner = void 0;
/**
 * Check if the access level allows for setting permissions.
 * Should probably be renamed to isSolutionManager.
 */
const isSolutionOwner = (access) => {
    return access === "owner";
};
exports.isSolutionOwner = isSolutionOwner;
